<template>
  <v-content>
    <v-row class="layout" wrap>
      <v-col cols="12">
        <div v-show="loading" class="loading">
          <v-progress-circular
              :size="70"
              :width="7"
              class="animation"
              color="primary"
              indeterminate
          />
        </div>
        <v-alert :value="success" type="success">{{ $t("NEWSLETTER_UNREGISTERED_SUCCESSFULLY") }}</v-alert>
        <v-alert :value="error" type="info">{{ $t("NEWSLETTER_NOT_REGISTERED") }}</v-alert>
      </v-col>
    </v-row>
  </v-content>

</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {CustomerApi} from "@swagger";

@Component({
  components: {}
})
export default class NewsletterUnsubscribe extends BasicComponent {

  loading: boolean = true;
  success: boolean = false;
  error: boolean = false;

  get token() {
    return this.$route.params["token"];
  }

  created() {
    new CustomerApi(this.apiConfiguration).unregisterCustomer(this.token).then(() => {
      this.success = true;
      this.loading = false;
    }).catch((err) => {
      err.json().then(error => {
        this.error = error;
        this.loading = false;
      });
    });
  }

  mounted() {
    this.trackPage("Newsletter Abmeldung");
  }
}

</script>
<style lang="scss" scoped>

.layout {
  margin-top: 10px;
}

.loading {
  display: inline-block;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

.imprintContent {
  margin-top: 25px;
}

</style>
<style lang="scss">

</style>
